import { ChangeDetectionStrategy,Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { OrderLineStatusFlags, OrderLineStatusValues } from 'app/shared/graph';
import { StatusColorComponentDirective } from 'app/shared/utilities/status-color.component';

@Component({
    selector: 'admin-line-status',
    templateUrl: './line-status.component.html',
    styleUrls: ['./line-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [StatusColorComponentDirective, MatIcon, MatTooltip]
})
export class LineStatusComponent {
    @Input()
    status: OrderLineStatusValues;

    @Input()
    flags?: OrderLineStatusFlags | null;

    constructor() {
    }
}
